import { parseHTML } from '~/helpers';

/**
 * Renders recommendations using the Product Recommendations API.
 *
 * @attribute url - The recommendations endpoint.
 */
customElements.define(
  'product-recommendations',
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      fetch(this.getAttribute('url'))
        .then((response) => response.text())
        .then((response) => {
          const element = parseHTML(response, 'product-recommendations');

          if (element) {
            this.innerHTML = element.innerHTML;
          }
        });
    }
  }
);
